export default "__VITE_ASSET__FnbAuVIH__"